import { RefreshCw } from 'lucide-react';
import { formatDistanceToNow, parseISO } from 'date-fns';
import { Button } from '@/components/ui/button';

interface LastUpdatedIndicatorProps {
  generatedAt: string | undefined;
  onRefresh: () => void;
  isRefreshing?: boolean;
}

export function LastUpdatedIndicator({
  generatedAt,
  onRefresh,
  isRefreshing = false,
}: LastUpdatedIndicatorProps) {
  const relative = generatedAt
    ? formatDistanceToNow(parseISO(generatedAt), { addSuffix: true })
    : null;

  return (
    <div className="flex items-center gap-2 text-xs text-text-secondary justify-end">
      {relative && <span>Last updated {relative}</span>}
      <Button
        variant="ghost"
        size="sm"
        className="h-6 px-2 text-xs"
        onClick={onRefresh}
        disabled={isRefreshing}
        aria-label="Refresh dashboard"
      >
        <RefreshCw className={`h-3 w-3 ${isRefreshing ? 'animate-spin' : ''}`} />
      </Button>
    </div>
  );
}
